module.exports = __webpack_public_path__ + "static/media/Ethpar_Logotype.08d6a83a.png";